import {
  ApiBlueprint,
  createFrontendPlugin,
  createRouteRef,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { scorecardsApiRef, ScorecardsClient } from './api/ScorecardsApi';
import { EntityScorecardContent } from './components/EntityScorecardContent';
import { ENTITY_SCORECARD_TAB, SCORECARDS_BASE_PATH } from './routes';

export const rootRouteRef = createRouteRef();

const scorecardsApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: scorecardsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ScorecardsClient({ discoveryApi, fetchApi }),
    }),
});

const scorecardsPage = PageBlueprint.make({
  params: {
    path: SCORECARDS_BASE_PATH,
    title: 'E360 Scorecards',
    icon: <AssessmentIcon />,
    routeRef: rootRouteRef,
    // Lazy, so a module-level failure in the editor cannot break the whole plugin.
    loader: () =>
      import('./components/ScorecardsRoutes').then(m => <m.ScorecardsRoutes />),
  },
});

const scorecardTab = EntityContentBlueprint.make({
  name: 'scorecard',
  params: {
    // The segment `entityScorecardPath` links to (`/catalog/:ns/:kind/:name/scorecard`).
    path: ENTITY_SCORECARD_TAB,
    title: 'Scorecard',
    filter: entity => entity.kind === 'Component',
    loader: async () => <EntityScorecardContent />,
  },
});

export const scorecardsPlugin = createFrontendPlugin({
  pluginId: 'scorecards',
  routes: { root: rootRouteRef },
  extensions: [scorecardsApi, scorecardsPage, scorecardTab],
});
